import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import UncontrolledDefaultModal from 'components/Modal/UncontrolledDefaultModal';
import { FlexControllerV2 } from 'components/FlexControllerInput/V2';
import { Button, Row, Col } from 'reactstrap';

export const LoginAgentsModal = React.memo(
  ({
    agentsOptions,
    loginToAllowedQueuesOptionsMap,
    loginByAgentLoginAndQueueIds
  }) => {
    const systemConfiguration = useSelector(
      (state) => state.systemConfiguration
    );
    const { handleSubmit, control, errors, watch } = useForm();
    const selectedAgentLogin = watch('agent')?.value;

    const onSubmit = useCallback(
      async (data) => {
        const selectedAgent = data.agent;
        const selectedQueues = data.queues ?? [];

        if (!selectedAgent || selectedQueues.length === 0) {
          toast.warn('É necessário selecionar um agente e ao menos uma fila.');
          return;
        }

        const agentLogin = selectedAgent.value;
        const queuesToLogin = selectedQueues.map((q) => q.value);

        try {
          await loginByAgentLoginAndQueueIds({
            login: agentLogin,
            queuesToLogin
          });
          toast.success('Atendente logado nas filas com sucesso!');
        } catch (error) {
          toast.error(`Falha ao logar o atendente: ${selectedAgent.label}.`);
        }
      },
      [loginByAgentLoginAndQueueIds]
    );

    const queuesOptions = useMemo(() => {
      return loginToAllowedQueuesOptionsMap?.[selectedAgentLogin];
    }, [loginToAllowedQueuesOptionsMap, selectedAgentLogin]);

    return (
      <UncontrolledDefaultModal
        trigger={
          <Button
            color="success"
            size="sm"
            title="Exibe a lista de atendentes que estão logados no sistema, inclusive os que não estão logados em filas de chat. É possível logar esses atendentes em tais filas."
          >
            <i className="fas fa-sign-in-alt mr-2" />
            Logar Atendente
          </Button>
        }
        header="Logar Atendentes em Filas"
        title="Logar Atendentes em Filas"
        subtitle="Selecione o atendente e as filas nas quais ele deve ser logado."
        size="lg"
        body={
          <form onSubmit={handleSubmit(onSubmit)}>
            <Row className="px-3">
              <Col md="12" className="mb-3">
                <label>Atendente</label>
                <FlexControllerV2
                  type="select"
                  name="agent"
                  control={control}
                  options={agentsOptions}
                  errors={errors}
                  rules={{ required: 'Campo obrigatório' }}
                  placeholder="Selecione o atendente..."
                />
              </Col>
              <Col md="12" className="mb-3">
                <label>Filas</label>
                <FlexControllerV2
                  type="select"
                  name="queues"
                  control={control}
                  options={queuesOptions}
                  isMulti
                  closeMenuOnSelect={false}
                  errors={errors}
                  rules={{ required: 'Campo obrigatório' }}
                  placeholder="Selecione as filas..."
                />
              </Col>
            </Row>
            <Row className="px-3 justify-content-end">
              <Col xs="auto">
                <Button color="primary" type="submit">
                  Logar
                </Button>
              </Col>
            </Row>
          </form>
        }
        footer={({ closeModal }) => (
          <div
            className="modal-footer"
            style={{ paddingTop: '.5rem', paddingInline: '.75rem' }}
          >
            <Button
              type="button"
              color="danger"
              style={{
                backgroundColor: systemConfiguration.cancelation_button_color
              }}
              onClick={closeModal}
            >
              Fechar
            </Button>
          </div>
        )}
      />
    );
  }
);
